import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, X } from "lucide-react";

const STORAGE_KEY = "shonics_promo_dismissed_v1";

export default function PromoStrip() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem(STORAGE_KEY) === "1";
    if (!dismissed) setShow(true);
  }, []);

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, "1");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      className="relative z-40 h-10 bg-gradient-to-r from-[#063A24] via-[#0B5D3B] to-[#063A24] text-white flex items-center justify-center px-4 text-xs md:text-sm"
      data-testid="promo-strip"
    >
      <Sparkles className="w-3.5 h-3.5 text-[#D4AF37] mr-2 shrink-0" />
      <span className="hidden sm:inline">First-time customers save</span>
      <span className="sm:hidden">Save</span>
      <span className="font-serif text-base text-[#D4AF37] mx-2">10%</span>
      <span className="hidden sm:inline">on every service.</span>
      <Link
        to="/booking"
        className="ml-3 px-3 py-1 rounded-full bg-[#D4AF37] text-[#0B5D3B] font-semibold text-[11px] uppercase tracking-widest hover:bg-white transition-colors"
        data-testid="promo-strip-cta"
      >
        Claim
      </Link>
      <button
        onClick={dismiss}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-white/60 hover:text-white"
        aria-label="Dismiss"
        data-testid="promo-strip-close"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
